module.exports = __webpack_public_path__ + "static/img/water_drop.968d85a4.png";